var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 15.8333C14.1667 16.7538 14.9128 17.5 15.8333 17.5C16.7538 17.5 17.5 16.7538 17.5 15.8333C17.5 14.9128 16.7538 14.1667 15.8333 14.1667M14.1667 15.8333C14.1667 14.9128 14.9128 14.1667 15.8333 14.1667M14.1667 15.8333H5.83333M15.8333 14.1667V5.83333M5.83333 15.8333C5.83333 16.7538 5.08714 17.5 4.16667 17.5C3.24619 17.5 2.5 16.7538 2.5 15.8333C2.5 14.9128 3.24619 14.1667 4.16667 14.1667M5.83333 15.8333C5.83333 14.9128 5.08714 14.1667 4.16667 14.1667M15.8333 5.83333C14.9128 5.83333 14.1667 5.08714 14.1667 4.16667M15.8333 5.83333C16.7538 5.83333 17.5 5.08714 17.5 4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5C14.9128 2.5 14.1667 3.24619 14.1667 4.16667M4.16667 14.1667V5.83333M4.16667 5.83333C3.24619 5.83333 2.5 5.08714 2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5C5.08714 2.5 5.83333 3.24619 5.83333 4.16667M4.16667 5.83333C5.08714 5.83333 5.83333 5.08714 5.83333 4.16667M5.83333 4.16667H14.1667M8.33333 12.5V7.5L11.6667 12.5V7.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNft);
export default __webpack_public_path__ + "static/media/nft.3b05ae14d292e737f2955c984349c495.svg";
export { ForwardRef as ReactComponent };